/**
 * @author Beka Chkhaidze
 * @summary number increasing animation uisng window.requestAnimationFrame from x -> y
 */

import { humanReadableNum } from "./template";

let animationFrameId: number;

interface Props {
    element: HTMLElement;
    end: number;
    start?: number;
    duration?: number;
    innerTextPrefix?: string;
    innerTextSufix?: string;
    textFromatterFn?: any;
    useHumanReadableFormat?: boolean;
}
export const useNumIncrement = ({
    element,
    start = 0,
    end,
    duration = 2500,
    innerTextPrefix = "",
    innerTextSufix = "",
    textFromatterFn,
    useHumanReadableFormat = true,
}: Props): number => {
    let startTime: number | null = null;

    const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        let text = Math.floor(progress * (end - start) + start).toString();
        text = textFromatterFn ? textFromatterFn(text) : text;

        if (useHumanReadableFormat) {
            text = humanReadableNum(Number(text))?.toString()!;
        }
        if (element) {
            element.innerText = innerTextPrefix + text + innerTextSufix;
        }

        if (progress < 1) {
            animationFrameId = window.requestAnimationFrame(step);
        } else {
            // window.cancelAnimationFrame(animationFrameId);
        }
    };

    animationFrameId = window.requestAnimationFrame(step);

    return animationFrameId;
};
